import {
  formatDate,
  BaseTransaction,
  formatBalance,
  BaseellaStatusTitle,
  Currency,
} from '@ui/src';

import getGeneralLedgerStatusTitle from '../../general-ledger/helpers/get-gl-enum-names';

import cn from '../styles.module.css';

const formatExchangeList = (
  list: BaseTransaction[],
  currencies?: Currency[],
): BaseTransaction[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    let sellAmount;
    let buyAmount;

    const exchangeType =
      result.exchangeCurrencyFixedId === result.exchangeCurrencyFromId
        ? 'SELL'
        : 'BUY';

    if (exchangeType === 'SELL') {
      sellAmount = result?.sum;
      buyAmount = result?.exchangeCurrencyFlexibleSum;
    } else {
      sellAmount = result?.exchangeCurrencyFlexibleSum;
      buyAmount = result?.sum;
    }

    const sellCurrency = currencies?.find(
      (currency) => currency.id === result.exchangeCurrencyFromId,
    );

    const buyCurrency = currencies?.find(
      (currency) => currency.id === result.exchangeCurrencyToId,
    );

    const render: Record<string, any> = {
      transferDate: (
        <div>
          {result?.transferDate
            ? formatDate(result?.transferDate || '', true)
            : '—'}
        </div>
      ),
      exchangeDateOfRate: (
        <div>
          {result?.transferDate
            ? formatDate(result?.transferDate || '', true)
            : '—'}
        </div>
      ),
      exchangeRateSourceId: <div>{result?.exchangeRateSource?.name || ''}</div>,
      exchangeCurrencyFromId: <div>{result?.exchangeCurrencyFrom?.name}</div>,
      exchangeCurrencyToId: <div>{result?.exchangeCurrencyTo?.name}</div>,
      baseellaStatus: <div>{BaseellaStatusTitle[result.baseellaStatus]}</div>,
      sum: (
        <div>
          {sellAmount ? formatBalance(Number(sellAmount), sellCurrency) : '-'}
        </div>
      ),
      exchangeCurrencyFlexibleSum: (
        <div>
          {buyAmount ? formatBalance(Number(buyAmount), buyCurrency) : '-'}
        </div>
      ),
      senderAccountNumber: result?.senderAccount ? (
        <>
          <div>{result?.senderAccount?.description}</div>
          <div className={cn.accNumber}>
            {result?.senderAccount?.fullNumber}
          </div>
        </>
      ) : (
        result.senderAccountNumber
      ),
      recipientAccountNumber: result?.recipientAccount ? (
        <>
          <div>{result?.recipientAccount?.description}</div>
          <div className={cn.accNumber}>
            {result?.recipientAccount?.fullNumber}
          </div>
        </>
      ) : (
        result.recipientAccountNumber
      ),
      values: result.generalLedgerTransactions?.edges.map((el) => el.node),
    };

    result.render = render;

    const nextResult = {
      ...result,
      values:
        result.generalLedgerTransactions?.edges.map((el) => {
          const gl = el.node;

          const glCurrency = currencies?.find(
            (currency) => currency.id === gl?.currency.id,
          );

          return {
            ...gl,
            render: {
              transferDate: (
                <div>{formatDate(gl?.transferDate || '', true)}</div>
              ),
              currencyId: <div>{gl?.currency.name || ''}</div>,
              debitAccountId: <div>{gl?.debitAccount?.fullNumber || ''}</div>,
              creditAccountId: <div>{gl?.creditAccount?.fullNumber || ''}</div>,
              debitAccount: <div>{gl?.debitAccount?.description || ''}</div>,
              creditAccount: <div>{gl?.creditAccount?.description || ''}</div>,
              sum: <div>{formatBalance(gl.sum, glCurrency)}</div>,
              status: (
                <div>{getGeneralLedgerStatusTitle(gl?.status || '')}</div>
              ),
            },
          };
        }) || [],
    };

    return nextResult;
  });

  return nextList;
};

export default formatExchangeList;
